import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import '../../action-list-item/action-list/index.esm.js';
import { EGDSActionListItem } from '../../action-list-item/action-list-item/index.esm.js';
import '../../action-list-item/action-list-item-link/index.esm.js';
import { EGDSButton } from '../../button/button/index.esm.js';
import '../../button/paging-button/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import styles from '../../styles/uitk-egds-typeahead.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { liveAnnounce } from '../../utils/live-announce/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSTypeaheadResultItem extends React.Component {
  static displayName = 'EGDSTypeaheadResultItem';
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    const {
      data,
      onResultItemSelect,
      value
    } = this.props;
    onResultItemSelect(value, data);
  }
  // A safer way to get the sanitized name.
  // Doing so with regex string replacement throws a code QL exception
  getSanitizedName = name => {
    const Elem = document.createElement('div');
    Elem.innerHTML = name;
    return Elem.textContent;
  };
  render() {
    const {
      activeSuggestion,
      className,
      icon,
      index,
      name,
      stid,
      sanitized,
      subtext,
      contentRef,
      historyDetail
    } = this.props;
    const cssClassNames = getClassNameList(className, subtext ? 'uitk-typeahead-result-item has-subtext' : 'uitk-typeahead-result-item', activeSuggestion === true && 'uitk-typeahead-result-item-hover');
    if (activeSuggestion === true) {
      const sanitizedName = this.getSanitizedName(name);
      liveAnnounce(`${sanitizedName}`, undefined, undefined, contentRef);
    }
    let ariaLabel;
    let iconContent;
    let contentFirstLine;
    let contentSecondLine;
    const searchDetailID = `full-search-detail-${historyDetail || false}`;
    if (sanitized) {
      contentFirstLine = jsx("span", {
        children: name
      });
    } else {
      contentFirstLine = jsx("div", {
        className: getClassNameList('truncate'),
        children: jsx("span", {
          dangerouslySetInnerHTML: {
            __html: name
          }
        })
      });
      if (subtext) {
        contentSecondLine = jsx("div", {
          "data-stid": searchDetailID,
          className: getClassNameList('is-subText', 'truncate'),
          dangerouslySetInnerHTML: {
            __html: subtext
          }
        });
      }
    }
    if (icon) {
      iconContent = jsx(EGDSIcon, {
        name: icon,
        size: EGDSIconSize.SMALL
      });
    }
    if (subtext) {
      ariaLabel = `${name} ${subtext}`.replace(/(<([^>]+)>)/gi, '');
    } else {
      ariaLabel = name?.replace(/(<([^>]+)>)/gi, '');
    }
    return jsxs(EGDSActionListItem, {
      spacing: "relaxed",
      className: cssClassNames,
      "data-stid": stid && `${stid}-result-item`,
      "data-index": index,
      children: [jsx(EGDSButton, {
        "data-stid": stid && `${stid}-result-item-button`,
        onClick: this.handleClick,
        className: getClassNameList(subtext && 'has-subtext', `${stid}-result-item-button`, 'result-item-button'),
        "aria-label": ariaLabel,
        type: "button",
        isFullWidth: true
      }), jsxs(EGDSLayoutFlex, {
        children: [jsx(EGDSLayoutFlexItem, {
          alignSelf: "center",
          children: iconContent
        }), jsx(EGDSLayoutFlexItem, {
          children: jsxs("div", {
            className: getClassNameList('uitk-typeahead-button-label', 'truncate'),
            children: [contentFirstLine, contentSecondLine]
          })
        })]
      })]
    });
  }
}
export { EGDSTypeaheadResultItem };